// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__Fa_RJ","active":"Link_active__S_r9W"};